module.exports = __webpack_public_path__ + "img/NFT_pioneer_Kusama-slot_1.5be34c10.jpg";